<small class="debug">{{me}}</small>
@if (dynamicsInitialized) {
  <div>
    <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
    </dynamic-form>
    <hr/>
    <br/>
    <br/>
    <div  style="border: black 2px dashed; width: 275px; height: 105px; margin-right: 8px">
      <mat-label>NOTE: for best YouTube results with</mat-label><br/>
      <mat-label>auto-playback and audio, be sure to</mat-label><br/>
      <mat-label>install the WatchDog in the final</mat-label><br/>
      <mat-label>deployment of the SignPlayer</mat-label><br/>
    </div>
    <br/>
  </div>
}
